import { makeStyles } from "@material-ui/core";

export const LessonCollectableCategoryListStyles = makeStyles(() => ({
  scrollingDiv: {
    overflow: "scroll",
    overflowX: "hidden",
    maxHeight: "230px",
    width: "100%",
  },
}));
